<template>
  <el-tooltip
    :disabled="!showValue || multiple"
    class="item"
    effect="dark"
    :content="
      !multiple && showValue && options.length > 0
        ? valueKey === 'false'
          ? options.find((item) => item === showValue)
            ? options.find((item) => item === showValue)[labelKey]
            : ''
          : options.find((item) => item[valueKey] === showValue)[labelKey]
        : ''
    "
    placement="top"
  >
    <el-select
      v-if="customFilter"
      class="inputWidth"
      :value="showValue"
      :placeholder="placeholder || $t('search.choose')"
      v-bind="$attrs"
      :filter-method="filterMethod"
      :multiple="multiple"
      @change="change"
      clearable
    >
      <el-option
        v-for="(item, index) in options"
        :key="index"
        :label="item[labelKey] + (moreShowKey ? ' ' + item[moreShowKey] : '')"
        :value="item[valueKey]"
      ></el-option>
    </el-select>
    <el-select
      v-else
      class="inputWidth"
      :value="showValue"
      :placeholder="placeholder || $t('search.choose')"
      @focus="focus"
      v-bind="$attrs"
      @change="change"
      :multiple="multiple"
      clearable
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item[labelKey] + (moreShowKey ? ' ' + item[moreShowKey] : '')"
        :value="valueKey !== 'false' ? item[valueKey] : item"
      ></el-option>
    </el-select>
  </el-tooltip>
</template>

<script>
  import BASE_API from '@/api/dataBase.js';
  import XEUtils from 'xe-utils';
  export default {
    props: {
      value: {
        type: [String, Object, Array],
        default: '',
      },
      apiUrl: {
        type: String,
        default: '',
      },
      type: {
        type: String,
        default: 'ajaxSelect',
      },
      apiData: {
        type: Object,
        default: () => {},
      },
      placeholder: {
        type: String,
        default: '',
      },
      dataString: {
        // 请求回来的数据层级
        type: String,
        default: 'data',
      },
      valueKey: {
        // 展示value key
        type: String,
        default: 'value',
      },
      moreShowKey: {
        // 其他展示的字段
        type: String,
        default: '',
      },
      labelKey: {
        // 展示label key
        type: String,
        default: 'label',
      },
      method: {
        // 请求方法
        type: String,
        default: 'post',
      },
      // 回传类型
      valueType: {
        // string, object
        type: String,
        default: '',
      },
      // 是否自定义过滤查询
      customFilter: {
        type: Boolean,
        default: false,
      },
      // 查询入参为字符串拼接或对象
      apiDataStr: {
        type: Object,
        default: () => {},
      },
      //是否需要获取焦点
      isFocus: {
        type: Boolean,
        default: true,
      },
      multiple: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        options: [],
      };
    },
    computed: {
      showValue() {
        let value = '';
        if (this.multiple) {
          value = XEUtils.isNull(this.value) ? [] : this.value;
        } else {
          value =
            typeof this.value === 'object' && this.valueKey !== 'false'
              ? this.value
                ? this.valueKey !== 'false'
                  ? this.value[this.valueKey]
                  : this.value
                : ''
              : this.value;
        }
        return value;
      },
      ajaxUrl() {
        return this.type === 'dictSelect' ? BASE_API.DIC_CREDIT_API : this.apiUrl;
      },
    },
    mounted() {
      this.getOptions();
    },
    watch: {
      apiUrl() {
        this.getOptions();
      },
      value() {
        this.initValue();
      },
    },
    methods: {
      initValue() {
        if (
          this.valueType == 'object' &&
          this.value &&
          typeof this.value != 'object' &&
          this.options.length > 0
        ) {
          this.change(this.value);
        }
      },
      filterMethod(value) {
        this.getOptions(value);
      },
      focus() {
        if (this.isFocus) {
          this.getOptions();
        }
      },
      getOptions(value) {
        // if (!this.ajaxUrl || (this.apiDataStr && !value)) return; //必须输入过滤条件才展示内容
        if (!this.ajaxUrl) return; //
        const dataString = this.dataString.split('.');
        const method = this.method;
        let url = this.ajaxUrl;
        // let params = '';
        let params = {};
        if (!this.apiDataStr) {
          params = this.apiData;
          console.log(params);
        } else {
          XEUtils.objectEach(this.apiDataStr, (item, key) => {
            // 对象迭代器，只能用于遍历对象，性能高于 each
            this.apiDataStr[key] = value;
          });
          let sign = '&';
          if (this.ajaxUrl.indexOf('?') == -1) {
            sign = '?';
          }
          url = this.ajaxUrl + sign + XEUtils.serialize(this.apiDataStr);
        }
        this.$axios[method](url, this.apiData).then((res) => {
          if (res.data.code === 0) {
            let returnData = res.data;
            let options = [];
            dataString.forEach((item) => {
              returnData = returnData[item];
              options = returnData;
            });
            if (this.valueKey === 'false') {
              options = options.map((v) => {
                return {
                  value: v.value,
                  label: v.label,
                };
              });
            }
            this.options = options;
            // console.log(options)
            this.initValue();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      change(value) {
        if (this.valueType === 'string') {
          this.$emit('input', value);
          this.$emit('change', value);
          return;
        }
        if (
          (this.value !== null && typeof this.value === 'object') ||
          this.valueType === 'object'
        ) {
          // 如果是对象，回传对象
          let obj = {};
          obj = this.options.find((item) => {
            return item[this.valueKey] === value; //筛选出匹配数据
          });
          this.$emit('input', obj || {});
          this.$emit('change', obj || {});
        } else {
          this.$emit('input', value);
          this.$emit('change', value);
        }
      },
    },
  };
</script>
